export const randInt = (max: number): number => Math.floor(Math.random() * max);

export const randItem = <T>(arr: T[]): T => {
  const index = randInt(arr.length);
  return arr[index];
};
